import { useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

import { COURSE_CATALOG } from "../constants/courseCatalog";
import "./Pricing.css";

function Pricing() {
  const { user, userData } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const selectedCourseId = searchParams.get("selected");

  const displayName =
    userData?.name ||
    user?.displayName ||
    user?.name ||
    user?.email?.split("@")[0] ||
    "Learner";

  const selectedCourse = useMemo(
    () => COURSE_CATALOG.find((course) => course.id === selectedCourseId),
    [selectedCourseId]
  );

  const handlePrimaryAction = (courseId) => {
    if (user) {
      navigate(`/checkout?course=${courseId}`);
      return;
    }
    navigate("/auth");
  };

  return (
    <div className="pricing-page">
      <div className="pricing-shell">

        <div className="programs-heading">

  <h2>
    Choose Your <span>Program</span>
  </h2>

  <p>
    Industry-focused programs designed to help students
    build real projects, real skills, and real careers.
  </p>

</div>

<div className="new-programs-grid">

  {/* FRONTEND PROGRAM */}

  <div className="frontend-card">

    <span className="program-badge blue-badge">
      LIVE + PROJECT BASED
    </span>

    <h3>
      Frontend Development
      <br />
      Career Program
    </h3>

    <p>
      Master modern frontend development with React,
      JavaScript, responsive UI design, Git, APIs,
      debugging, deployment, and real-world project building.
    </p>
    <div className="mini-tags">
  <span>1 WEEK FREE DEMO</span>
  <span>BEGINNER FRIENDLY</span>
  <span>JOB READY</span>
</div>

    <div className="program-features">

      <div>✓ React + JavaScript</div>
      <div>✓ Git & GitHub</div>

      <div>✓ Real Projects</div>
      <div>✓ Resume Guidance</div>

      <div>✓ Portfolio Building</div>
      <div>✓ Interview Preparation</div>

    </div>

    <div className="program-bottom">

      <div>

        <span className="program-label">
          Program Fee
        </span>

        <h4>₹19,999</h4>

      </div>

      <div className="program-duration">

        <span>Duration</span>

        <strong>8–10 Weeks</strong>

      </div>

    </div>

   <button
  className="program-btn"
  onClick={() => handlePrimaryAction("frontend")}
>
  Enroll Now
</button>

  </div>

  {/* FULL STACK */}

  <div className="trainee-card">

    <span className="program-badge yellow-badge">
      COMING SOON
    </span>

    <h3>
      Full Stack Developer
      <br />
      Trainee Program
    </h3>

    <p>
      An advanced career-track program combining full stack
      development, production projects, mentorship,
      and internship-style trainee experience.
    </p>

    <div className="mini-tags">
  <span>INTERNSHIP STYLE</span>
  <span>REAL STARTUP PROJECTS</span>
  <span>CAREER TRACK</span>
</div>

    <div className="program-features">

      <div>✓ Frontend + Backend + Database</div>
      <div>✓ Internship Style Training</div>

      <div>✓ Real Startup Projects</div>
      <div>✓ Code Reviews & Mentorship</div>

      <div>✓ Team Collaboration</div>
      <div>✓ Certificate & Career Support</div>

    </div>

    <div className="trainee-highlight">

      Includes trainee + internship style experience
      with mentorship benefits.

    </div>

    <button
  className="program-btn trainee-btn"
  onClick={() => alert("Waitlist opening soon!")}
>
  Join Waitlist
</button>

  </div>

</div>
        {/* BOTTOM PANEL */}
        <section className="pricing-bottom-panel">
          <div>
            <span className="pricing-pill pricing-pill-secondary">
              What gets saved
            </span>

            <h3>
              Checkout securely stores your enrollment and payment details.
            </h3>
          </div>

          <div className="pricing-bottom-grid">
            <span>Unique user ID</span>
            <span>Name</span>
            <span>Email</span>
            <span>Phone number</span>
            <span>Selected course</span>
            <span>Total amount paid</span>
          </div>
        </section>

      </div>
    </div>
  );
}

export default Pricing;